// src/pages/ForgotPassword.js

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import "../styles/ForgotPassword.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notice, setNotice] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setNotice("");

    try {
      // POST /auth/forgot-password  { email }
      await api.post("/auth/forgot-password", { email });

      // Always show a generic success to avoid email enumeration UX
      setSent(true);
      setNotice(
        "If that email exists, we’ve sent a 6-digit reset code. It expires in 15 minutes."
      );
    } catch (err) {
      // Backend may return 404 (email not found) or 403 (inactive).
      // Keep the UX generic unless it’s clearly actionable.
      if (err?.response?.status === 403) {
        setError("This account is inactive. Please contact your administrator.");
      } else {
        setSent(true);
        setNotice(
          "If that email exists, we’ve sent a 6-digit reset code. It expires in 15 minutes."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-container page">
      <div className="forgot-card">
        <header className="forgot-header">
          <h1 className="forgot-title">Forgot your password?</h1>
          <p className="forgot-subtitle">
            Enter your email and we&apos;ll send you a 6-digit code to reset it.
          </p>
        </header>

        {notice && (
          <p className="success-message" role="status">
            {notice}
          </p>
        )}
        {error && (
          <p className="error-message" role="alert">
            {error}
          </p>
        )}

        <form onSubmit={onSubmit} className="forgot-form">
          <div className="forgot-field-group">
            <label htmlFor="forgot-email" className="forgot-label">
              Email
            </label>
            <input
              id="forgot-email"
              type="email"
              className="forgot-input"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading || sent}
              placeholder="you@school.ie"
            />
          </div>

          {!sent && (
            <button
              className="forgot-primary-btn"
              type="submit"
              disabled={loading}
            >
              {loading ? "Sending…" : "Send reset code"}
            </button>
          )}
        </form>

        {sent && (
          <div className="forgot-continue">
            <button
              className="forgot-secondary-btn"
              onClick={() =>
                navigate(`/reset-password?email=${encodeURIComponent(email)}`)
              }
            >
              Continue to reset
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
